import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import store from './Store'
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import { AuthProvider } from "./contexts/AuthContext"
import { BrowserRouter as Router } from "react-router-dom"

const theme = createTheme({
  palette: {
    primary: { main: green[800]},
    secondary: { main: green[800]},
  },
  typography: {
      fontSize: 12,
  },
});


ReactDOM.render(
  <React.StrictMode>
  <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
    <Router>
      <AuthProvider>
      <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
      </Provider>
    </AuthProvider>
  </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
